var render, staticRenderFns
import script from "./AddToCartButton.vue?vue&type=script&lang=js"
export * from "./AddToCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600e081a')) {
      api.createRecord('600e081a', component.options)
    } else {
      api.reload('600e081a', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/AddToCartButton.vue"
export default component.exports